<template>
  <b-link
    :to="{ name: 'legal', params: { version: $props.version } }"
    :target="$props.target"
  >
    {{ $t('legal_link') }}
    <span v-if="$props.version">({{ $props.version }})</span>
  </b-link>
</template>

<script>
export default {
  name: 'LinkLegal',
  props: {
    target: {
      default: '_blank',
    },
    version: {
      default: null,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/elements/links/Legal.vue